import { ReactNode } from "react";
import { Heading } from "../Type";
import styles from "./index.module.scss";

type PropsType = {
  title: string;
  children: ReactNode | ReactNode[];
};

const OpenCard = ({ title, children }: PropsType) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <Heading size="h5">{title}</Heading>
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default OpenCard;
